import {createContext, useContext} from "react";


export interface IConfig {
    server: string;
    contentServer:string;
    isAdmin:boolean;
}
export const ConfigContext = createContext<IConfig|null>(null);

export const WantsAdminContext = createContext<[boolean, (newVal: boolean) => void]>([false, (b:boolean) => {}]);

export function useConfig() {
    const retval = useContext(ConfigContext);
    if (retval === null) {
        throw new Error('config has not been initialized properly!');
    }
    return retval;
}

export function useIsAdmin() {
    const config = useConfig();
    const [wantsAdmin,] = useContext(WantsAdminContext);

    return config.isAdmin && wantsAdmin;
}
export function useCanBeAdmin() {
    const retval = useContext(ConfigContext);
    return retval?.isAdmin ?? false;
}